import axios from 'axios';

const api = axios.create({
   baseURL: import.meta.env.VITE_API_URL || '/api',
   timeout: 10000,
   headers: {
      'Content-Type': 'application/json',
   },
});

api.interceptors.request.use(
   (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
         config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
   },
   (error) => {
      return Promise.reject(error);
   }
);

api.interceptors.response.use(
   (response) => {
      return response;
   },
   (error) => {
      const currentPath = window.location.pathname;

      if (error.response?.status === 401) {
         if (currentPath !== '/login' && currentPath !== '/change-password') {
            localStorage.removeItem('authToken');
            window.location.href = '/login';
         }
      } else if (error.response?.status === 403) {
         const errorCode = error.response?.data?.code;
         if (errorCode === 'PASSWORD_CHANGE_REQUIRED') {
            console.log('🔐 Password change required, redirecting...');
            if (currentPath !== '/change-password') {
               window.location.href = '/change-password';
            }
         }
      }
      return Promise.reject(error);
   }
);

export default api;
